module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-container",
    class: _vm.containerClass,
    on: {
      "click": _vm.hideLanding
    }
  }, [_c('h1', {
    staticClass: "color-blue upcase text-center content-translate",
    class: _vm.subHeaderInactive
  }, [_vm._v("Welcome To")]), _vm._v(" "), _c('div', {
    staticClass: "landing-header upcase text-center content-translate",
    class: _vm.headerInactive
  }, [_vm._v("Changing Minds")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b9dc4a1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organisms/landing.vue
// module id = 605
// module chunks = 1